module.exports = __webpack_public_path__ + "img/bg-must-sti-booking.c0105a70.svg";